// src/components/PageWrapper.jsx
import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

const variants = {
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.3 },
  },
  slideUp: {
    initial: { opacity: 0, y: 40 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -40 },
    transition: { duration: 0.4, ease: 'easeOut' },
  },
  slideLeft: {
    initial: { opacity: 0, x: 80 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -80 },
    transition: { duration: 0.4, ease: 'easeInOut' },
  },
  zoomIn: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
    transition: { duration: 0.35, ease: 'easeInOut' },
  },
  rotateIn: {
    initial: { opacity: 0, rotate: -5, scale: 0.98 },
    animate: { opacity: 1, rotate: 0, scale: 1 },
    exit: { opacity: 0, rotate: 5, scale: 0.98 },
    transition: { duration: 0.45, ease: 'easeOut' },
  },
};

export default function PageWrapper({
  children,
  effect = 'fade',
  enabled = false,
}) {
  const variant = variants[effect] || variants.fade;

  if (!enabled) {
    return (
      <div
        style={{
          position: 'absolute',
          width: '100%',
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <motion.div
      initial={variant.initial}
      animate={variant.animate}
      exit={variant.exit}
      transition={variant.transition}
      style={{
        position: 'absolute',
        width: '100%',
      }}
    >
      {children}
    </motion.div>
  );
}

PageWrapper.propTypes = {
  children: PropTypes.node,
  effect: PropTypes.oneOf(Object.keys(variants)),
  enabled: PropTypes.bool,
};
